(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('uploadMedia', uploadMedia);

    /* @ngInject */
    function uploadMedia() {
        var directive = {
            bindToController: true,
            templateUrl: 'upload-media.tpl',
            controller: uploadMediaController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.pageType = angular.isDefined(scope.$root.stats.term) ? 'team' : 'seller';
        }
    }

    /* @ngInject */
    function uploadMediaController($scope, $rootScope, $http,$route) {

        $scope.save = function() {
            var fd = new FormData();
            if ($scope.$root.uploadMediaValue == 'image') {
                var file = angular.element('[name="media-file"]')[0].files[0];
                if (file) {   // quick-n-dirty
                    fd.append('media-file', file, file.name);
                    fd.append('params[target]', ($scope.$root.uploadImg == false) ? 'page-image' : 'photo');
                    fd.append('params[hq][video-image][value]', 'image');
                } else {  //remove
                    fd.append('params' + (!$scope.$root.uploadImg ? '[hq][page-image][value]' : '[photo][value]'), '');
                }
            } else {
                var vcode = angular.element('[name="video"]').val();
                if (vcode) {
                    vcode = vcode.trim().match(/([^=\/]+)$/)[1];
                }
                fd.append('params[hq][video][value]', vcode);
                fd.append('params[hq][video-image][value]', (vcode ? 'video' : 'image'));
            }
            fd.append('method', 'save_' + $scope.vm.pageType + '_data');
            fd.append('action', 'pie_action');
            fd.append('nonce', $rootScope.stats.nonce);
            $http.post(ajaxurl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function(response) {
                if (response.data.result) {
                    $route.reload();
                    angular.element('.overlay.active').removeClass('active');
                }
            });
        };

        $scope.close = function() {
            angular.element('.overlay.active').removeClass('active');
        };
        $scope.remove = function() {
            if ($scope.$root.uploadMediaValue == 'image') {
                angular.element('[name="media-file"]').val(null);
            } else {
                angular.element('[name="video"]').val(null);
            }
            $scope.save();
        };

    }

})();